import { setObjects } from '../helpers';

const initialState = () => ({
    storage: { },
    compliments: { },
    remarks: { },
})

const mutations = {
    ADD_FEEDBACK (state, feedbacks) {
        setObjects(feedbacks, state.storage, { })
    },
    ADD_COMPLIMENTS (state, compliments) {
        setObjects(compliments, state.compliments, { })
    },
    ADD_REMARKS (state, remarks) {
        setObjects(remarks, state.remarks, { })
    },
}

export default {
    initialState,
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/feedback.js